import React from 'react';

import { useForm } from 'react-hook-form';

import { makeStyles, Theme } from '@material-ui/core';

import {} from '../homeSlice';
import FilterFormFields from './FilterFormFields';
import Form from '../../../common/components/Form';

export interface FilterFormData {
  arrival: number;
  firstSituation: string;
  secondSituation: string;
}

export const FILTER_DEFAULT_VALUE: FilterFormData = {
  arrival: 3,
  firstSituation: 'Todos',
  secondSituation: '',
};

const useStyles = makeStyles((theme: Theme) => ({
  formFilter: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
}));

interface FilterFormnProps {
  onSubmit: (data: FilterFormData) => void;
}

const FilterForm = ({ onSubmit }: FilterFormnProps) => {
  const classes = useStyles();

  const methods = useForm<FilterFormData>({
    defaultValues: { ...FILTER_DEFAULT_VALUE },
    mode: 'onChange',
  });

  const { control, handleSubmit } = methods;

  return (
    <Form onSubmit={handleSubmit(onSubmit)} methods={methods}>
      <FilterFormFields className={classes.formFilter} control={control} />
    </Form>
  );
};

export default FilterForm;
